<template>
  <div>
  <Menu></Menu>
    <main>
        <div class=" d-flex w-100 h-100 p-5 mx-auto flex-column ">
        <div class="container">
            <div class="row">

                <br>
    <h2>Libro de Reclamaciones Virtual</h2>
    
    <form @submit.prevent="enviarReclamacion">
      <h3>1. Identificación del Consumidor</h3>
      <input type="text" v-model="form.nombreCompleto" placeholder="Nombre Completo" required />
      
      <select v-model="form.tipoDocumento" required>
        <option value="">Seleccione Documento</option>
        <option value="DNI">DNI</option>
        <option value="CE">Carnet de Extranjería</option>
        <option value="Pasaporte">Pasaporte</option>
      </select>
      
      <input type="text" v-model="form.numeroDocumento" placeholder="Número de Documento" required />
      <input type="email" v-model="form.email" placeholder="Correo Electrónico" required />
      <input type="text" v-model="form.telefono" placeholder="Teléfono" />
      <input type="text" v-model="form.direccion" placeholder="Dirección Domiciliaria" />

      <h3>2. Detalle del Bien Contratado</h3>
      <label>
        <input type="radio" value="Producto" v-model="form.tipoBien" required /> Producto
      </label>
      <label>
        <input type="radio" value="Servicio" v-model="form.tipoBien" /> Servicio
      </label>
      <input type="text" v-model="form.codigoPedido" placeholder="Nº Pedido o Factura" />
      <input type="number" v-model="form.montoReclamado" placeholder="Monto Reclamado (Opcional)" step="0.01" />

      <h3>3. Detalle de la Reclamación</h3>
      <label>
        <input type="radio" value="Reclamo" v-model="form.tipoSolicitud" required /> Reclamo
      </label>
      <label>
        <input type="radio" value="Queja" v-model="form.tipoSolicitud" /> Queja
      </label>
      
      <textarea v-model="form.descripcion" placeholder="Detalle lo sucedido..." required></textarea>
      <textarea v-model="form.pedidoUsuario" placeholder="¿Qué solución solicita?" required></textarea>

      <br />
      <label>
        <input type="checkbox" v-model="form.aceptaTerminos" required /> Declaro que los datos son verdaderos.
      </label>

      <button type="submit" :disabled="cargando">
        {{ cargando ? 'Enviando...' : 'Enviar Reclamación' }}
      </button>
    </form>

    <p v-if="respuesta" class="exito">{{ respuesta }}</p>
    <p v-if="error" class="error">{{ error }}</p>
            </div>
        </div>
        </div>
    </main>
  <footer class=" text-white">
    <div class="container">
        <div class="col-lg-12 footer ">
            <div class="row">
                <div class="col-md-5">
                    <img src="@/assets/img/logo-vertical.png" alt="" width="250">
                     <p>Un servicio de Kallpa Securities S.A.B.</p>
                    <p>RUC: 20492942121</p>                 
 
                </div>
                <div class="col-md-4">
                    <h4>Síguenos en:</h4>
                    <a href="https://facebook.com/kallpasablima" target="_blank"><i class="fab fa-facebook-square"></i> @Kallpasablima</a> <br>
                    <a href="https://www.instagram.com/kallpasab/" target="_blank"><i class="fab fa-instagram"></i> @kallpasab</a> <br>
                    <a href="https://twitter.com/KallpaSAB" target="_blank"><i class="fab fa-twitter-square"></i> @KallpaSAB</a> <br>
                    <a href="https://www.linkedin.com/company/kallpa-educa/?viewAsMember=true" target="_blank"><i class="fab fa-linkedin"></i> @KallpaSAB</a>
                    <p></p>
                    <p><a  @click="$router.push('/Reclamos').catch(err => {})"><img src="@/assets/img/LibRec.png" alt="reclamo" width="50"> Libro de Reclamaciones</a></p>
                </div>
                <div class="col-md-3">
                    <h4 class="cnt">Contáctanos</h4>
                    <ul class="list-footer">
                        <li><i class="fas fa-phone"></i> 630-7500 Anexo 195</li>
                        <li><i class="fas fa-mobile-alt"></i> 940131392</li>
                        <li><i class="fas fa-envelope"></i> clientes@kallpacambios.com</li>
                        <li><i class="fas fa-map-marker-alt"></i>Jr. Monterosa 233 oficina 902,Chacarilla del Estanque, Santiago de Surco.</li>
                        <li>Horario de atención: {{horaInicio}} - {{horaFin}}</li>
                    </ul>
            </div>
            </div>
        </div>
        <hr>
        <div class="col-lg-12 copyright">
            <div class="row d-flex">
                <p class="col-md-8">2021. Kallpa Securities Sociedad Agente de Bolsa // Kallpa Cambios. Todos los derechos reservados. </p>
                <p class="col-md-2"><a :href="urlPoliticasSeguridad" target="_blank" class="poli-term">Políticas de privacidad</a></p>
                <p class="col-md-2"><a :href="urlTerminosCondiciones" target="_blank" class="poli-term">Términos y condiciones</a></p>
            </div>
        </div>
    </div>
</footer>
  </div>
</template>

<script>
import axios from 'axios';
import Menu from "@/layouts/Menu";

export default {
  name: 'FormularioReclamo',
  components: {
    Menu,
  },
  data() {
    return {
      form: {
        nombreCompleto: '',
        tipoDocumento: '',
        numeroDocumento: '',
        telefono: '',
        email: '',
        direccion: '',
        tipoBien: '',
        codigoPedido: '',
        montoReclamado: null,
        tipoSolicitud: '',
        descripcion: '',
        pedidoUsuario: '',
        rutaAdjunto: '', // De momento vacío
        aceptaTerminos: false
      },
      cargando: false,
      respuesta: '',
      error: ''
    };
  },
  methods: {
    async enviarReclamacion() {
      this.cargando = true;
      this.respuesta = '';
      this.error = '';

      try {
        // Reemplaza con la URL local que te dé tu IIS Express al correr .NET 4.8
        //const urlAPI = 'https://localhost:44352/api/reclamaciones'; 
        const urlAPI = 'https://login.kallpasab.com/KallpaReclamos/api/reclamaciones';
        const axiosLimpio = axios.create({
        headers: {} 
        });
        const res = await axiosLimpio.post(urlAPI, this.form);
        
        this.respuesta = `${res.data.Mensaje}. Número de caso: #${res.data.Id}`;
        this.resetForm();
      } catch (err) {
        this.error = 'Hubo un error al enviar el reclamo. Inténtalo de nuevo.';
        console.error(err);
      } finally {
        this.cargando = false;
      }
    },
    resetForm() {
      this.form = {
        nombreCompleto: '', tipoDocumento: '', numeroDocumento: '', telefono: '',
        email: '', direccion: '', tipoBien: '', codigoPedido: '', montoReclamado: null,
        tipoSolicitud: '', descripcion: '', pedidoUsuario: '', rutaAdjunto: '', aceptaTerminos: false
      };
    }
  }
};
</script>

<style scoped>
.formulario-container { max-width: 600px; margin: auto; padding: 20px; font-family: sans-serif; }
input[type="text"], input[type="email"], input[type="number"], select, textarea { 
  display: block; width: 100%; margin-bottom: 12px; padding: 10px; box-sizing: border-box; 
}
textarea { height: 100px; resize: vertical; }
button { padding: 12px 24px; background-color: #007bff; color: white; border: none; cursor: pointer; font-size: 16px; }
button:disabled { background-color: #ccc; cursor: not-allowed; }
.exito { color: #28a745; font-weight: bold; margin-top: 15px; }
.error { color: #dc3545; font-weight: bold; margin-top: 15px; }
label { display: inline-block; margin-right: 15px; margin-bottom: 10px; cursor: pointer; }
</style>


// WEBPACK FOOTER //
// src/components/pages/FormularioReclamo.vue